import { Scale } from 'modules/questionnaires/lib/types'

export const RatingDefaultValues = {
  minValue: 0,
  maxValue: 10,
}

export const setLabels = (defaultRatingScale: Scale[]) => {
  const min = RatingDefaultValues.minValue
  const max = RatingDefaultValues.maxValue
  const labels = []

  for (let value = min; value <= max; value++) {
    const text = defaultRatingScale.find((r) => r.value === value)?.text || ''
    labels.push({ value, text })
  }

  return labels
}
